const headerData = [{
		types: "selection",
		columnwidth: 40,
	},
	{
		prop: "CusCode",
		label: "经销商编号",
		columnwidth: 120,
	},
	{
		prop: "CusName",
		label: "经销商名称",
		columnwidth: 150,
	},
	{
		prop: "RebateRatio",
		label: "返利点",
		columnwidth: 80,
	}
];
export default headerData;